import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language.toLowerCase().startsWith('en');

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-5 text-primary">
      <div className="w-full max-w-md text-center">
        <p className="text-sm font-semibold text-secondary">404</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight">
          {isEnglish ? 'Page not found' : 'Stranica nije pronađena'}
        </h1>
        <p className="mt-3 text-sm leading-6 text-secondary">
          {isEnglish
            ? 'The address may be incorrect or the page may have been removed.'
            : 'Adresa možda nije ispravna ili je stranica uklonjena.'}
        </p>
        <Link
          to="/"
          className="mt-7 inline-flex h-10 items-center justify-center rounded-lg bg-primary px-5 text-sm font-semibold text-background hover:bg-primary-hover"
        >
          {isEnglish ? 'Return to chat' : 'Nazad na razgovor'}
        </Link>
      </div>
    </main>
  );
}
